<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            COMPLIANCE / Taxation
          </div>

          <el-tabs v-model="activeTab" @tab-click="handleClick">
            <el-tab-pane label="Sales Tax Portal" name="first">

              <el-tabs v-model="activeTabSTMInternal" @tab-click="handleClick">
                <el-tab-pane label="Tax Accounts" name="sTaxLibrary">
                  <sTaxLibrary ref="sTaxLibrary"/>
                </el-tab-pane>
                <!-- <el-tab-pane label="GL (Tax Accounts)" name="sGL">
                  <sGL ref="sGL"/>
                </el-tab-pane> -->
                <el-tab-pane label="Tax Reporting" name="taxReporting">
                  <tax-reporting ref="taxReporting"/>
                </el-tab-pane>
                <!-- <el-tab-pane label="Summary List of Sales (Output)" name="summaryList">
                  <summary-list ref="summaryList" />
                </el-tab-pane> -->
                <el-tab-pane label="Summary List of Purchases (Input)" name="fifth">{{msg}}</el-tab-pane>
                <el-tab-pane label="Summary List of Importations (Input)" name="sixth">{{msg}}</el-tab-pane>
              </el-tabs>

            </el-tab-pane>
            <el-tab-pane label="Sales Tax Forms (Gvt)" name="second">{{msg}}</el-tab-pane>
            <el-tab-pane label="Withholding Tax Portal" name="third">

              <el-tabs v-model="activeTabWTMInternal" @tab-click="handleClick">
                <el-tab-pane label="Tax Accounts" name="wTaxLibrary">
                  <wTaxLibrary ref="wTaxLibrary"/>
                </el-tab-pane>
                <el-tab-pane label="GL (Tax Accounts)" name="wTaxAccountResult">
                  <w-tax-account-result ref="wTaxAccountResult" />
                </el-tab-pane>
                <el-tab-pane label="Tax Reporting" name="third">{{msg}}</el-tab-pane>
                <el-tab-pane label="Alphalist of Expanded Withholding Tax" name="fourth">{{msg}}</el-tab-pane>
                <el-tab-pane label="Alphalist of Creditable Withholding Tax" name="fifth">{{msg}}</el-tab-pane>
                <el-tab-pane label="Alphalist of Employees Withholding Tax" name="sixth">{{msg}}</el-tab-pane>
              </el-tabs>

            </el-tab-pane>
            <el-tab-pane label="Withholding Tax Forms (Gvt)" name="fourth">{{msg}}</el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sTaxLibrary from '@/components/taxation/salesTaxPortal/sTaxLibrary.vue'
import wTaxLibrary from '@/components/taxation/withholdingTaxPortal/wTaxLibrary.vue'
import WTaxAccountResult from "../components/taxation/withholdingTaxPortal/wTaxAccountResult";
import axios from 'axios'
let moment = require('moment');
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import TaxReporting from "../components/taxation/salesTaxPortal/TaxReporting";
import SummaryList from "../components/taxation/salesTaxPortal/SummaryList";

export default {
  name: 'Taxation',
  components: {
    WTaxAccountResult,
    SweetModal,
    sTaxLibrary,
    wTaxLibrary,
    TaxReporting,
    SummaryList,
  },
  data() {
    return {
      tableData: [],
      activeTab: 'first',
      activeTabSTMInternal: 'sTaxLibrary',
      activeTabWTMInternal: 'wTaxLibrary',

      msg: 'Sorry, this feature now under development will be ready later.',
    }
  },
  mounted () {
    this.$refs['sTaxLibrary'].loadList()
  },
  methods: {
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    handleClick(tab, event) {
      if (tab.name === 'first'){
        this.activeTabSTMInternal = 'sTaxLibrary'
        this.$refs['sTaxLibrary'].loadList()
      } else if (tab.name === 'third') {
        this.activeTabWTMInternal = 'wTaxLibrary'
        this.$refs['wTaxLibrary'].loadList()
      } else if (tab.name === 'wTaxAccountResult') {
        this.$refs['wTaxAccountResult'].loadList()
      } else if (tab.name === 'summaryList') {
        this.$refs['summaryList'].loadList()
      }

      if (tab.name === 'sTaxLibrary'){
        this.$refs['sTaxLibrary'].loadList()
      } else if (tab.name === 'taxReporting') {
        this.$refs['taxReporting'].loadFirstTab()
      }

      if (tab.name === 'wTaxLibrary'){
        this.$refs['wTaxLibrary'].loadList()
      }

    }
  },
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
